import { render, staticRenderFns } from "./FormRadioColor.vue?vue&type=template&id=775e9985&"
import script from "./FormRadioColor.vue?vue&type=script&lang=js&"
export * from "./FormRadioColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports